module.exports = __webpack_public_path__ + "static/media/Infinity-1s-200px.ee045e04.svg";